import T from "utils/T";

const EXERCISE_COLUMNS = [
  T(''),
  T('월'),
  T('화'),
  T('수'),
  T('목'),
  T('금'),
  T('토'),
  T('일'),
  T('주중'),
  T('주말')
];

export default EXERCISE_COLUMNS;